import {
  createContext,
  useContext,
  useEffect,
  useSyncExternalStore,
  type ReactNode,
} from 'react';
import {
  applyThemeToDocument,
  browserThemeStore,
  type ResolvedTheme,
  type ThemeStore,
} from '../lib/theme';

const ThemeContext = createContext<ResolvedTheme | null>(null);

interface ThemeProviderProps {
  children: ReactNode;
  store?: ThemeStore;
}

export function ThemeProvider({
  children,
  store = browserThemeStore,
}: ThemeProviderProps): JSX.Element {
  const theme = useSyncExternalStore(
    store.subscribe,
    store.getSnapshot,
    store.getServerSnapshot,
  );

  useEffect(() => {
    applyThemeToDocument(theme);
  }, [theme]);

  return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>;
}

export function useTheme(): ResolvedTheme {
  const theme = useContext(ThemeContext);
  if (!theme) throw new Error('useTheme must be used within ThemeProvider');
  return theme;
}
